import { useEffect } from "react";
import useAnalytics from "./useAnalytics";
import { useRouter } from "next/router";

const usePageViewOnSearch = (makerId?: number): void => {
  const { pageView } = useAnalytics(makerId);
  const router = useRouter();
  useEffect(() => {
    const handleRouteChange = (url) => pageView(url);

    // Routerのイベントリスナーを登録する
    router.events.on("routeChangeComplete", handleRouteChange);

    // 初回のページビューを送信する
    pageView();

    // コンポーネントのアンマウント時にイベントリスナーを解除する
    return () => router.events.off("routeChangeComplete", handleRouteChange);
  }, []);
};

export default usePageViewOnSearch;
